<template>
  <main class="main" role="main">
    <div class="page">
      <div class="inner">
        <div class="lnb">
          <ul>
            <li><p class="home"></p></li>
            <li><p>협회 소개</p></li>
            <li><p>찾아오는 길</p></li>
          </ul>
        </div>
        <div class="page_ttl">
          <h1 class="h1">
            <span>찾아오는 길</span>
          </h1>
        </div>
        <div class="page_con">
          <div id="map" style="height: 400px;"></div>
          <div class="contact_info">
            <div class="contact_info_ttl">
              <img src="@/assets/static/images/logo_type02.svg" alt="">
              <span>사단법인 한국외식산업협회</span>
            </div>
            <div class="contact_info_con">
              <div class="line">
                <dl>
                  <dt>주소</dt>
                  <dd>서울시 서초구 양재동 232번지 AT센터 1101호</dd>
                </dl>
              </div>
              <div class="line">
                <dl>
                  <dt>Tel</dt>
                  <dd>+82-2-449-5009</dd>
                </dl>
                <dl>
                  <dt>Fax</dt>
                  <dd>+82-2-6300-8361</dd>
                </dl>
              </div>
            </div>
          </div>
          <div class="transport_list">
            <ul class="transport_list_ul">
              <li class="transport_list_li">
                <div class="left">
                  <div class="transport_list_ttl">
                    <span class="icon subway"></span>
                    <span>지하철</span>
                  </div>
                  <div class="transport_list_con">
                    <div class="line">
                      <span class="color">신분당선 양재시민의숲역 4번 출구</span>로 나와서<br>
                      aT센터까지 약 200m 걷기
                    </div>
                  </div>
                </div>
                <div class="right">
                  <div class="transport_list_ttl">
                    <span class="icon bus"></span>
                    <span>버스</span>
                  </div>
                  <div class="transport_list_con">
                    <div class="line">
                      140, 400, 407, 408, 421, 440, 441, 462, 470, 471 번 이용<br>
                      <span class="color">AT센터, 양재 꽃시장 정류장</span>에서 하차
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <ul class="transport_list_ul">
              <li class="transport_list_li">
                <div class="left">
                  <div class="transport_list_ttl">
                    <span class="icon car"></span>
                    <span>자가용 - 서울에서 오실 때</span>
                  </div>
                  <div class="transport_list_con">
                    <div class="line">
                      <p class="bold">강남역 방향에서 오시는 길</p>
                      <span>
                                                강남역에서 강남대로 성남, 양재동 방면에서 직진,<br>
                                                양재 시민의 숲 지나서 우측 aT센터 주차장으로 진입
                                            </span>
                    </div>
                    <div class="line">
                      <p class="bold">잠실 방향에서 오시는 길</p>
                      <span>
                                                잠실역 사거리에서 종합운동장 방면으로 직진하여<br>
                                                강남역 사거리에서 성남, 양재방면으로 좌회전하여 직진,<br>
                                                양재 시민의 숲 지나서 우측 aT센터 주차장으로 진입
                                            </span>
                    </div>
                  </div>
                </div>
                <div class="right">
                  <div class="transport_list_con">
                    <div class="line">
                      <p class="bold">강남 고속터미널 방향에서 오시는 길</p>
                      <span>
                                                제일생명 사거리에서 우회전하여 성남, 양재방면으로<br>
                                                직진, 양재 시민의 숲 지나서 우측 aT센터 주차장으로 진입
                                            </span>
                    </div>
                    <div class="line">
                      <p class="bold">강북 방향에서 오시는 길</p>
                      <span>
                                                한남대교를 건너서 강남역, 양재역, 성남 방면으로 직진,<br>
                                                양재 시민의 숲 지나서 우측 aT센터 주차장으로 진입
                                            </span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <ul class="transport_list_ul">
              <li class="transport_list_li">
                <div class="left">
                  <div class="transport_list_ttl">
                    <span class="icon car"></span>
                    <span>자가용 - 수도권에서 오실 때</span>
                  </div>
                  <div class="transport_list_con">
                    <div class="line">
                      <p class="bold">인천 방향에서 오시는 길</p>
                      <span>
                                                서울 외곽 고속도로 판교 방향으로 진행하시다가 학의JC에서<br>
                                                진출하여 의왕·과천 고속도로 진입후 경마장 옆으로 진행,<br>
                                                양재대로로 합류하여 잠실 방면으로 직진하다가 양재 IC 지나 바로<br>
                                                염곡사거리에서 좌회전하여 첫번째 횡단보도에서 U턴하자마자<br>
                                                오른쪽 주차장 입구로 지하주차장 진입<br>
                                                <span class="small">염곡사거리의 교통혼잡으로 인해 상기 약도 안내에서처럼<br>
                                                우회하여 오시는 것이 안전합니다</span>
                                            </span>
                    </div>
                  </div>
                </div>
                <div class="right">
                  <div class="transport_list_con">
                    <div class="line">
                      <p class="bold">강화, 김포 방향에서 오시는 길</p>
                      <span>
                                                88올림픽도로로 진입하여 잠실 방향으로 주행하시다가<br>
                                                반포대교지나 한남대교 아래에서 우회전하여 성남 방면으로 직진<br>
                                                신사역, 논현역, 강남역, 양재역, 양재 시민의 숲 지나서<br>
                                                우측 aT센터 주차장으로 진입
                                            </span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <ul class="transport_list_ul">
              <li class="transport_list_li">
                <div class="left">
                  <div class="transport_list_ttl">
                    <span class="icon car"></span>
                    <span>자가용 - 지방에서 오실 때</span>
                  </div>
                  <div class="transport_list_con">
                    <div class="line">
                      <p class="bold">경부 고속도로로 오시는 길</p>
                      <span>
                                                서울 방향으로 진행하시다가 양재 인터체인지에서 가락동<br>
                                                농수산물 시장 방향으로 직진하여첫번째 사거리 (염곡동 사거리)<br>
                                                에서 좌회전하여 첫번째 횡단보도에서 U턴하자마자 오른쪽 <br>
                                                주차장 입구로 지하주차장 진입<br>
                                                <span class="small">염곡사거리의 교통혼잡으로 인해 상기 약도 안내에서처럼 우회하여<br>
                                                오시는 것이 안전합니다</span>
                                            </span>
                    </div>
                  </div>
                </div>
                <div class="right">
                  <div class="transport_list_con">
                    <div class="line">
                      <p class="bold">경부 고속도로, 구리 방향에서 오시는 길</p>
                      <span>
                                                중부고속도로 방향(구리 방향은 강동대교를 건너서)에서는<br>
                                                88올림픽도로 김포 방향으로 진입하여 직진하시다가 한남대교 <br>
                                                아래에서 강남대로 방면으로 진입하여 성남 방면으로 직진 <br>
                                                신사역, 논현역, 강남역, 양재역, 양재 시민의 숲 지나서 <br>
                                                우측 aT센터 주차장으로 진입
                                            </span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'about-road-index',
  description: '찾아오는길',
  mounted() {
    if (window.kakao && window.kakao.maps) {
      this.initMap();
    } else {
      const script = document.createElement('script')
      /* global kakao */
      script.onload = () => kakao.maps.load(this.initMap)
      script.src = `${location.protocol}//dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=1f9c162d5946ab0faec64ac5992f118c`
      // script.src = 'http://dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=1f9c162d5946ab0faec64ac5992f118c'
      document.head.appendChild(script)
    }
  },
  methods: {
    initMap() {
      let container = document.getElementById('map')
      let options = {
        center: new kakao.maps.LatLng(37.468278, 127.0389221),
        level: 4
      }
      let map = new kakao.maps.Map(container, options)
      map.setMapTypeId(kakao.maps.MapTypeId.NORMAL)
      let markerPosition  = new kakao.maps.LatLng(37.468278, 127.0389221)
      let marker = new kakao.maps.Marker({
        position: markerPosition
      })
      marker.setMap(map)
    }
  }
}
</script>

<style scoped>

</style>
